<template>
  <div id="app">
    <login></login>
    <menutop></menutop>
    <div class="container-fluid" id="dvconteudoapp">
      <router-view></router-view>
    </div>      
  </div>
</template>
<style>
  #dvconteudoapp{
    margin-top: 2px;
    padding: 0 0 15px 0;
    transition: padding-left 0.25s ease;
    border-top: 1px solid rgba(140, 105, 205, 0.22);
  }
  #dvcrud{
    margin-bottom: 15px;
  }
  #app{
    background-color: var(--draco-surface, white);
  }
  @media (min-width: 992px) {
    #dvconteudoapp{
      padding-left: 50px;
    }
    body.draco-sidenav-open #dvconteudoapp{
      padding-left: 250px;
    }
  }
  @media (max-width: 991px) {
    #dvconteudoapp{
      padding-left: 0;
    }
  }
</style>
<script>

import menutop from './views/menutop.vue'
import login from './views/login'
import util from './utilitarios/util'


export default {
  name: 'app',
  components: {   
      'menutop' : menutop,
      'login'   : login
  },
	  mounted:function(){
	    this.mtdaplicarabstracaoGlobal();
	  },
		  methods:{
		    mtdaplicarabstracaoGlobal(){
		      let vself = this;
		      vself.$nextTick(function(){
		        const crudContainer = document.querySelector('#dvcrud');
		        if (crudContainer) {
		          const cadastroCard = crudContainer.querySelector('#pncadastro');
		          if (cadastroCard) {
		            const cadastroBody = cadastroCard.querySelector('.card-body');
		            const hasTabbedLayout = cadastroCard.querySelector('.nav.nav-tabs, .tab-content') !== null;
		            if (!hasTabbedLayout) {
		              if (cadastroBody) {
		                cadastroBody.classList.add('draco-sections-ready');
		              }
		              cadastroCard.classList.add('draco-layout-ready');
		            }
		          }
		        }
		        util.transformartabssanfona(vself);
		      });
		    }
	  },
	  watch:{
	    $route(){
	      this.mtdaplicarabstracaoGlobal();
	    }
	  },
  computed: {
  }
}
</script>
